import { useContext } from 'react';

import { UnitShiftContext } from '@/contexts';

export const useUnitShiftContext = () => useContext(UnitShiftContext);
